"use client";
import React, { useEffect } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useRouter } from "next/router";
import styles from "./Loading.module.css";

const Loading = ({ isOpen, userStatus, tokenDetails }: any) => {
  const router = useRouter();
  const APPLY_PORTAL = process.env.RMS_APPLY_PORTAL;
  const SMS_PORTAL = process.env.RMS_SMS_PORTAL;

  useEffect(() => {
    if (!userStatus || !tokenDetails) return;

    const params = `access_token=${encodeURIComponent(
      tokenDetails.access_token
    )}&refresh_token=${encodeURIComponent(tokenDetails.refresh_token)}`;

    const url =
      userStatus === "NEW_LEAD"
        ? `${APPLY_PORTAL}dashboard?${params}`
        : userStatus === "EXISTING_STUDENT"
        ? `${SMS_PORTAL}dashboard/?${params}`
        : "";

    const timeoutId = setTimeout(() => {
      router.push(url);
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [isOpen, userStatus, tokenDetails, router]);

  const handleUserPortal = () => {
    if (userStatus === "NEW_LEAD") {
      return "Apply portal";
    } else if (userStatus === "EXISTING_STUDENT") {
      return "Student portal";
    }
  };

  return (
    <>
      <Modal
        show={isOpen}
        backdrop="static"
        keyboard={false}
        centered
        size="lg"
        dialogClassName={styles.modal}
        contentClassName={styles.modalContent}
      >
        <div className={styles.topContainer}>
          <div>
            <Spinner
              animation="border"
              variant="success"
              style={{ width: "50px", height: "50px" }}
            />
          </div>
          <div className={styles.textContainer}>
            <p className={styles.text}>
              Redirecting to the {handleUserPortal()}. Please do not close the
              window or press back.
            </p>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Loading;
